export function isUniverseChainId(chainId) {
  return !!chainId && ALL_CHAIN_IDS.includes(chainId);
}
export var UniverseChainId = /* @__PURE__ */ ((UniverseChainId2) => {
  UniverseChainId2[UniverseChainId2["H2"] = 2582] = "H2";
  return UniverseChainId2;
})(UniverseChainId || {});
export const SUPPORTED_CHAIN_IDS = [
  2582 /* H2 */
  // H2 Chain
];
export const SUPPORTED_TESTNET_CHAIN_IDS = [];
export const ALL_CHAIN_IDS = [...SUPPORTED_CHAIN_IDS];
export var RPCType = /* @__PURE__ */ ((RPCType2) => {
  RPCType2["Public"] = "public";
  RPCType2["Private"] = "private";
  RPCType2["PublicAlt"] = "public_alternative";
  RPCType2["Interface"] = "interface";
  RPCType2["Fallback"] = "fallback";
  RPCType2["Default"] = "default";
  return RPCType2;
})(RPCType || {});
export var NetworkLayer = /* @__PURE__ */ ((NetworkLayer2) => {
  NetworkLayer2[NetworkLayer2["L1"] = 0] = "L1";
  NetworkLayer2[NetworkLayer2["L2"] = 1] = "L2";
  return NetworkLayer2;
})(NetworkLayer || {});
